import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useClearFilters } from './hooks/useClearFilters';

type ClearFiltersProps = {
	onClick?: () => void;
};

export const ClearFilters: React.FC<ClearFiltersProps> = ({ onClick }) => {
	const {
		data: { hideButton },
		actions: { clearRefinements, trackClearFiltersClick },
	} = useClearFilters();

	if (hideButton) {
		return null;
	}

	return (
		<Button
			onClick={() => {
				trackClearFiltersClick();
				clearRefinements();
				if (onClick) {
					onClick();
				}
			}}
			data-testid="clear-filters"
			variant="tertiary"
			className="py-0"
			data-qa="clear-filters-button"
		>
			<Translate value="corgi.search.filters.clear_filters.title" />
		</Button>
	);
};
